import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';
import SegmentHeader from '@appComponents/SegmentHeader';
import Chip from '@ui/Chip';
import {formatSpiideoChipLabel, getSpiideoChipProps} from '@modules/events/utils/spiideoChipColor';

const columns = {
    outcome: {
        label: 'Outcome',
        content: {
            singleLine: true,
        },
    },
    attempt_datetime: {
        label: 'Attempt time',
        content: {
            singleLine: true,
        },
    },
    message: {
        label: 'Message',
    },
};

const rowRenderer = (column, row) => {
    switch (column) {
        case 'outcome':
            return row.outcome ? (
                <Chip
                    size='small'
                    label={formatSpiideoChipLabel(row.outcome)}
                    {...getSpiideoChipProps(row.outcome)}
                />
            ) : '—';
        case 'attempt_datetime':
            return row.attempt_datetime || '—';
        case 'message':
            return row.message || '—';
        default:
            return null;
    }
};

const SpiideoReconciliationHistory = ({attempts}) => {
    if (!attempts?.length) {
        return null;
    }

    return (
        <div>
            <SegmentHeader>Reconciliation attempts</SegmentHeader>
            <Table
                name='spiideoReconciliationAttempts'
                data={attempts}
                columns={columns}
                rowRenderer={rowRenderer}
                pagination={false}
                className='mini spiideo-reconciliation-table'
            />
        </div>
    );
};

SpiideoReconciliationHistory.propTypes = {
    attempts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        outcome: PropTypes.string,
        message: PropTypes.string,
        attempt_datetime: PropTypes.string,
    })).isRequired,
};

export default SpiideoReconciliationHistory;
